import type {Subject as CommentBoxSubject} from '../subject'

export type SubjectType = 'issue' | 'pull_request' | 'project' | 'commit'

export type SavedRepliesContext = 'issue' | 'pull_request'

/**
 * Describes the location on GitHub of the Markdown being edited.
 */
export interface ApiMarkdownSubject {
  subjectType: SubjectType
  subjectRepoId?: number
  subjectId?: string
  lineNumber?: number
  path?: string
}
export const ApiMarkdownSubject = {
  fromPropsSubject: (subject: CommentBoxSubject | undefined): Partial<ApiMarkdownSubject> => {
    if (!subject) {
      return {}
    }

    if (subject.type === 'project') {
      return {
        subjectId: subject.id?.databaseId?.toString(),
        subjectType: subject.type,
      }
    }

    return {
      subjectId: subject.id?.databaseId?.toString() ?? subject.id?.id,
      subjectRepoId: subject.repository.databaseId,
      subjectType: broadenSubjectType(subject.type),
    }
  },
}

function broadenSubjectType(type: CommentBoxSubject['type']): ApiMarkdownSubject['subjectType'] {
  switch (type) {
    case 'issue_comment':
      return 'issue'
    case 'pull_request_comment':
    case 'pull_request_body':
      return 'pull_request'
  }

  return type
}
